import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, Box } from '@mui/material';

const LATE_REASONS = {
  ARRIVED_LATE: 'Kunde verspätet eingetroffen',
  MARKED_LATE_PRESENT: 'Kunde verspätet als eingetroffen markiert',
};

const CUSTOMER_DELAY_REASONS = [
  'Keine Angabe',
  'Verkehrsstau',
  'ÖPNV-Verspätung',
  'Parkplatzsuche',
  'Zu spät auf den Weg gemacht',
  'Sonstiger Grund',
];

function LateArrivalDialog({ open, onClose, onSelectReason }) {
  const [showReasonSelection, setShowReasonSelection] = useState(false);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const customReasonRef = useRef(null);

  useEffect(() => {
    if (!open) {
      setShowReasonSelection(false);
      setShowCustomInput(false);
      if (customReasonRef.current) {
        customReasonRef.current.value = '';
      }
    }
  }, [open]);

  const handleArrivedLateClick = () => {
    setShowReasonSelection(true);
  };

  const handleMarkedLatePresentClick = () => {
    onSelectReason(LATE_REASONS.MARKED_LATE_PRESENT);
  };

  const handleReasonSelect = (reason) => {
    onSelectReason(reason);
    setShowReasonSelection(false);
    setShowCustomInput(false);
  };

  const handleCustomReasonClick = () => {
    setShowCustomInput(true);
  };

  const handleCustomReasonConfirm = () => {
    const value = customReasonRef.current?.value?.trim();
    const reason = value || 'Sonstiger Grund';
    onSelectReason(reason);
    setShowReasonSelection(false);
    setShowCustomInput(false);
    if (customReasonRef.current) {
      customReasonRef.current.value = '';
    }
  };

  const handleCustomReasonCancel = () => {
    setShowCustomInput(false);
    if (customReasonRef.current) {
      customReasonRef.current.value = '';
    }
  };

  const handleCustomReasonKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleCustomReasonConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Verspätung dokumentieren</DialogTitle>
      <DialogContent sx={{px: 3, pt: 0, pb: 1 }}>
        <Typography variant='body1' sx={{ mb: 2 }}>
          Der Kunde ist verspätet eingetroffen. Bitte wähle die passende Option, um die Ankunft zu
          dokumentieren.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 1,
          px: 3,
          pb: 2,
          '& > *:not(:first-of-type)': { ml: 0 },
        }}
      >
        {!showReasonSelection && (
          <>
            <Button onClick={handleArrivedLateClick} variant='outlined' fullWidth>
              {LATE_REASONS.ARRIVED_LATE}
            </Button>
            <Button onClick={handleMarkedLatePresentClick} variant='outlined' fullWidth>
              {LATE_REASONS.MARKED_LATE_PRESENT}
            </Button>
          </>
        )}
        {showReasonSelection &&
          CUSTOMER_DELAY_REASONS.map((reason) => (
            reason === 'Sonstiger Grund' && showCustomInput ? (
              <Box key='custom-reason-input' display='flex' gap={1} flexDirection='column'>
                <TextField
                  inputRef={customReasonRef}
                  label='Sonstiger Grund'
                  placeholder='Grund eingeben'
                  size='small'
                  fullWidth
                  autoFocus
                  onKeyDown={handleCustomReasonKeyDown}
                />
                <Box display='flex' gap={1}>
                  <Button onClick={handleCustomReasonConfirm} variant='contained' fullWidth>
                    Übernehmen
                  </Button>
                  <Button onClick={handleCustomReasonCancel} variant='outlined' fullWidth>
                    Abbrechen
                  </Button>
                </Box>
              </Box>
            ) : (
              <Button
                key={reason}
                onClick={() =>
                  reason === 'Sonstiger Grund' ? handleCustomReasonClick() : handleReasonSelect(reason)
                }
                variant='outlined'
                fullWidth
              >
                {reason}
              </Button>
            )
          ))}
      </DialogActions>
    </Dialog>
  );
}

export default LateArrivalDialog;
